import { Injectable } from '@angular/core';
import { SiteListForUserApiModel } from './Models/SiteListForUserApiModel';
import { HttpUtils } from '../../../http/HttpUtils';

@Injectable({
    providedIn: 'root'
})

export class SiteListForUserApi
{
    private apiUrl = '/api/site/list-for-user';

    public async Get(): Promise<SiteListForUserApiModel>
    {
        const response = await fetch(this.apiUrl);

        await HttpUtils.ProcessFetchResultAsync(response);

        return await response.json() as SiteListForUserApiModel;
    }
}
